{
  "pt": {
    "timestamp": {
      "labels": {
        "accepted": "Aceite {date}",
        "ago": "atrás",
        "daysAgo": "{days} dia |{days} dias",
        "daysRemaining": "{days} dias restantes",
        "due": "Devido {date}",
        "dueToday": "Prazo para entrega hoje",
        "expired": "Expirado {date}",
        "hoursAgo": "{hours} hora | {hours} horas",
        "in": "Em {time}",
        "justNow": "Agora mesmo",
        "minutesAgo": "{minutes} minuto | {minutes} minutos",
        "monthsAgo": "{months} mês | {months} meses",
        "noDeadline": "Sem prazo definido",
        "overdue": "Vencido com {days} dias",
        "sentOn": "Enviado em {date}",
        "sentOnAt": "Enviado em {date} às {time}",
        "starts": "Começa {date}",
        "today": "Hoje",
        "tomorrow": "Amanhã",
        "uploaded": "Carregado {date}",
        "weeksAgo": "{weeks} semana | {weeks} semanas",
        "yearsAgo": "{years} ano | {years} anos",
        "yesterday": "Ontem"
      }
    }
  }
}
